import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
import { IconPlus } from "@/assets/icons";
import { CountTable } from "@/components/elements/CountTable";
import { ECompanyContractStatus } from "@/types/enum";
import { useCompanyList } from "@/api/services/admin/company";

type TTopListProps = {
  contractStatuses: ECompanyContractStatus[];
};

export const TopList: FC<TTopListProps> = ({ contractStatuses }) => {
  const { data } = useCompanyList(contractStatuses);
  const contractStatus = contractStatuses.length && contractStatuses[0];
  const isEnableButtonCreate = contractStatus && [ECompanyContractStatus.DURING_CONTRACT, ECompanyContractStatus.TRIAL].includes(contractStatus);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <CountTable total={data?.pagination.total} page={data?.pagination.page} perPage={data?.pagination.perPage} />

      {isEnableButtonCreate && (
        <Button component={Link} size="sm" to={AppRoutes.companyCreate} startIcon={<IconPlus />}>
          新規顧客登録
        </Button>
      )}
    </Stack>
  );
};
